export const TYWallCarriersLeadDemographicsState = [
  {
    label: 'Age',
    dataKey: 'AgeGroup'
  },
  {
    label: 'Credit Rating',
    dataKey: 'CreditRating'
  },
  {
    label: 'Gender',
    dataKey: 'Gender'
  },
  {
    label: 'Homeownership',
    dataKey: 'HomeOwner'
  },
  {
    label: 'Home Type',
    dataKey: 'HomeType'
  },
  {
    label: 'Current Insurance Company',
    dataKey: 'InsuranceCompany'
  },
  {
    label: 'Multiple Vehicles',
    dataKey: 'MultiCar'
  },
  {
    label: 'Pets',
    dataKey: 'Pets'
  },
  {
    label: 'State',
    dataKey: 'State'
  }
];
